import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdateTermMutation = graphql.persisted(
  "UpdateTerm",
  graphql(`
    mutation UpdateTerm($input: UpdateTermInput!) {
      updateTerm(input: $input) {
        term {
          id
          name
          slug
          position
          startsOn
          endsOn
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateTermMutation };

export function useUpdateTerm() {
  return useMutation(UpdateTermMutation);
}
